// extracted by mini-css-extract-plugin
module.exports = {"storeDetailsContainer":"P71StoreDetailsPage_storeDetailsContainer__9Q60M","storeDetailsContent":"P71StoreDetailsPage_storeDetailsContent__OzxH9"};